import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { WuerthEisosCredentialsInputDTORuntype, WuerthEisosResponseBodyDTORuntype } from './wuerthEisosBackendTypes';

export const wuerthEisosEndpoints = {
    'GET /3rdparty/wuertheisos/credentials': endpoint({
        description: 'Returns credentials for wuertheisos integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: WuerthEisosResponseBodyDTORuntype,
    }),
    'POST /3rdparty/wuertheisos/credentials': endpoint({
        description: 'Uploads credentials for wuertheisos API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: WuerthEisosCredentialsInputDTORuntype,
        responseBody: WuerthEisosResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/wuertheisos/credentials'],
    }),
    'PATCH /3rdparty/wuertheisos/credentials': endpoint({
        description: 'Updates credentials for wuertheisos API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: WuerthEisosCredentialsInputDTORuntype,
        responseBody: WuerthEisosResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/wuertheisos/credentials'],
    }),
    'DELETE /3rdparty/wuertheisos/credentials': endpoint({
        description: 'Deletes existing credentials for wuertheisos API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/wuertheisos/credentials'],
    }),
};
